<form [formGroup]="tad_solicitors_details_form">
  <fieldset class="form-group">
    <div class="row">
      <div class="col-12">
        <legend>Have you appointed a solicitor?</legend>
      </div>
      <div class="col-12 col-md-6">
        <div class="d-flex">
          <div class="w-40 mr-1">
            <div class="c-radio--separated">
              <span class="c-radio-button">
                <input type="radio" formControlName="tad_solicitor_required" name="tad_solicitor_required" [checked]="tad_solicitor_required.value == true" id="true" value="true">
                <label class="c-radio-button__label" for="true">
                  <span class="c-radio-button__faux">Yes</span>
                  <svg class="c-radio-button__faux-indicator icon-tick" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 13"><path fill="#f9b114" d="M5.57 7.53L2.78 4.79 0 7.53l2.78 2.73L5.57 13l2.78-2.74L16 2.74 13.22 0 5.57 7.53z" /></svg>
                </label>
              </span>
            </div>
          </div>
          <div class="w-40">
            <div class="c-radio--separated">
              <span class="c-radio-button">
                <input type="radio" formControlName="tad_solicitor_required" name="tad_solicitor_required" [checked]="tad_solicitor_required.value == false" id="false" value="false">
                <label class="c-radio-button__label" for="false">
                  <span class="c-radio-button__faux">No</span>
                  <svg class="c-radio-button__faux-indicator icon-tick" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 13"><path fill="#f9b114" d="M5.57 7.53L2.78 4.79 0 7.53l2.78 2.73L5.57 13l2.78-2.74L16 2.74 13.22 0 5.57 7.53z" /></svg>
                </label>
              </span>
            </div>
          </div>
          <div class="w-20"></div>
        </div>

      </div>
    </div>
  </fieldset>

  <div>
    <div class="c-block c-block--bordered">
      <h5>Finding the right solicitor</h5>
      <p class="mb-0">
        Any solicitors you choose must be registered with the Law Society  and have a minimum of  two partners registered with the Solicitors Regulation Authority.
      </p>
    </div>

    @if (tad_solicitor_required.value == 'true') {
      <fieldset>
        <div class="row">
          <div class="col col-md-6">
            <div class="form-group" [ngClass]="setDynamicClassesForFormgroup('tad_solicitor_name')">
              <label for="tad_solicitor_name">Name of solicitor</label>
              <input type="text" class="form-control" id="tad_solicitor_name" [ngClass]="setDynamicClasses('tad_solicitor_name')"
                formControlName="tad_solicitor_name" aria-describedby="tad_solicitor_name">
                <small id="tad_solicitor_name" class="form-text text-muted">This is the person's name.</small>
                <together-auction-dip-validate-fields [displayError]="tad_solicitors_details_form.get('tad_solicitor_name').touched && tad_solicitors_details_form.get('tad_solicitor_name').errors?.required" errorMsg="We need to know the solicitors name."></together-auction-dip-validate-fields>
              </div>
              <div class="form-group" [ngClass]="setDynamicClassesForFormgroup('tad_solicitor_firm_name')">
                <label for="tad_solicitor_firm_name">Name of solicitor's firm</label>
                <input type="text" class="form-control" id="tad_solicitor_firm_name" [ngClass]="setDynamicClasses('tad_solicitor_firm_name')"
                  formControlName="tad_solicitor_firm_name" aria-describedby="tad_solicitor_name">
                  <small id="tad_solicitor_firm_name" class="form-text text-muted">This is the name of the company for the solicitor.</small>
                  <together-auction-dip-validate-fields [displayError]="tad_solicitors_details_form.get('tad_solicitor_firm_name').touched && tad_solicitors_details_form.get('tad_solicitor_firm_name').errors?.required" errorMsg="We need to know the company your solicitor works for."></together-auction-dip-validate-fields>
                </div>
                <div class="form-group">
                  <label>Address</label>
                  <app-address [incomingAddress]="address" [addressLookUp]="tad_solicitors_details_form.controls.addresslookup" (form_out)="_handleIncomingForm($event)"></app-address>
                </div>
                <div class="form-group">
                  <label for="tad_solicitor_email">Email address</label>
                  <input type="email" class="form-control" id="tad_solicitor_firm_email" formControlName="tad_solicitor_firm_email" aria-describedby="tad_solicitor_name">
                  <small id="tad_solicitor_name" class="form-text text-muted">This is the email address of the solicitor you are using.</small>
                </div>
                <div class="form-group" [ngClass]="setDynamicClassesForFormgroup('tad_solicitor_firm_phone')">
                  <label for="tad_solicitor_phone">Telephone number</label>
                  <input type="text" class="form-control" id="tad_solicitor_firm_phone" [ngClass]="setDynamicClasses('tad_solicitor_firm_phone')" formControlName="tad_solicitor_firm_phone" aria-describedby="tad_solicitor_name">
                  <small id="tad_solicitor_firm_phone" class="form-text text-muted">This is the phone number of the solicitor you are using.</small>
                  <together-auction-dip-validate-fields [displayError]="tad_solicitors_details_form.get('tad_solicitor_firm_phone').touched && tad_solicitors_details_form.get('tad_solicitor_firm_phone').errors?.required" errorMsg="We need the solicitors phone number."></together-auction-dip-validate-fields>
                </div>
              </div>
            </div>
          </fieldset>
        }

      </div>
    </form>

    <together-auction-dip-stage-select [forward_title]="'Review your application'" [backward_title]="'Additional loan details'" [show_action]="false" [show_forward]="true" [show_backward]="true" (on_forward)="_handleForward($event)" (on_backward)="_handleBackward($event)">
    </together-auction-dip-stage-select>
    <together-auction-dip-loading [is_loading]="_isLoading"></together-auction-dip-loading>
